// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"106":"9c8faeef","623":"1cc97578","660":"2565d025","667":"c11eba20","680":"6dde8aaf","748":"39c4c5da","825":"791ae9b8"}[chunkId] + ".chunk.css";
};